module.exports = __webpack_public_path__ + "img/baking-ingredients1.30c3e4c8.jpeg";